import { GetterTree } from 'vuex'
import { State } from '@/store/store'
import MapState from './states'

const getters: GetterTree<MapState, State> = {
  getMapUserLocation: (state) => {
    return state.user
  },
  getMapPatientLocation: (state) => {
    return state.user
  },
}

export default getters
